// todo move to rest-api
export const mobileProviders = [
  { value: '@sms.airfiremobile.com', label: 'Airfire Mobile' },
  { value: '@sms.alltelwireless.com', label: 'Alltel (Allied Wireless)' },
  { value: '@paging.acswireless.com', label: 'Ameritech' },
  { value: '@txt.att.net', label: 'AT&T' },
  { value: '@bellsouth.cl', label: 'BellSouth' },
  { value: '@sms.bluecell.com', label: 'Bluegrass Cellular' },
  { value: '@sms.myboostmobile.com', label: 'Boost Mobile' },
  { value: '@cbeyond.sprintpcs.com', label: 'C Beyond (All Page Wireless)' },
  { value: '@cspire1.com', label: 'C Spire Wireless' },
  { value: '@cellcom.quiktxt.com', label: 'Cellcom' },
  { value: '@csouth1.com', label: 'Cellular South' },
  { value: '@sms.cvalley.net', label: 'Chariton Valley Wireless' },
  { value: '@mail.msgsender.com', label: 'Chat Mobility' },
  { value: '@mobile.mycingular.com', label: 'Cingular' },
  { value: '@sms.cleartalk.us', label: 'Cleartalk' },
  { value: '@mms.cricketwireless.net', label: 'Cricket' },
  { value: '@sms.advantagecell.net', label: 'DTC' },
  { value: '@sms.edgewireless.com', label: 'Edge Wireless' },
  { value: '@SMS.elementmobile.net', label: 'Element Mobile' },
  { value: '@echoemail.net', label: 'Esendex' },
  { value: '@iwirelesshometext.com', label: 'i-wireless (Sprint PCS)' },
  { value: '@mobile.kajeet.net', label: 'Kajeet' },
  { value: '@text.longlines.com', label: 'LongLines' },
  { value: '@mymetropcs.com', label: 'MetroPCS' },
  { value: '@sms.ntwls.net', label: 'Nextech' },
  { value: '@zsend.com', label: 'Pioneer Cellular' },
  { value: '@qwestmp.com', label: 'Qwest Wireless' },
  { value: '@smtext.com', label: 'Simple Mobile' },
  { value: '@rinasms.com', label: 'South Central Communications' },
  { value: '@page.southernlinc.com', label: 'Southernlinc' },
  { value: '@messaging.sprintpcs.com', label: 'Sprint' },
  { value: '@teleflip.com', label: 'Teleflip' },
  { value: '@message.ting.com', label: 'Ting' },
  { value: '@tmomail.net', label: 'T-Mobile' },
  { value: '@utext.com', label: 'Unicel' },
  { value: '@union-tel.com', label: 'Union Wireless' },
  { value: '@email.uscc.net', label: 'US Cellular' },
  { value: '@usamobility.net', label: 'USA Mobility' },
  { value: '@vtext.com', label: 'Verizon Wireless' },
  { value: '@viaerosms.com', label: 'Viaero' },
  { value: '@vmobl.com', label: 'Virgin Mobile' },
  { value: '@text.voyagermobile.com', label: 'Voyager Mobile' },
  { value: '@sms.wcc.net', label: 'West Central Wireless' }
]
